import { Icon } from '../../shared/Icon/Icon';
import { useFormModalStore } from '../../../stores/formStore';
import styles from './FormBtn.module.less';

const FormBtn = ({ theme }: { theme: string; isMenu?: boolean }) => {
  const { openModal } = useFormModalStore();
  return (
    <div
      onClick={openModal}
      className={`${styles.btn}  ${theme !== 'light' && styles.btn__dark}`}
    >
      <Icon
        id="ask"
        className={`${styles.icon} ${theme !== 'light' && styles.iconLight} `}
      />
    </div>
  );
};

export default FormBtn;
